import { createSelector } from 'reselect';
import { PodcastWorkflowTemplate } from 'redux/middleware/api/podcast-service';
import { entitiesSelector } from './base';

export const podcastWorkflowTemplatesSelector = createSelector(
  entitiesSelector,
  entities => entities?.get('podcastWorkflowTemplates'),
);

export const podcastWorkflowTemplateSelector = (id: string) =>
  createSelector(
    podcastWorkflowTemplatesSelector,
    podcastWorkflowTemplates =>
      podcastWorkflowTemplates?.get(id)?.toJS() as PodcastWorkflowTemplate,
  );

export const templateLockSpecUuidSelector = (templateId: string) =>
  createSelector(
    podcastWorkflowTemplatesSelector,
    templates =>
      templates
        ?.get(templateId)
        ?.getIn(['previewConfiguration', 'lockSpec', 'uuid']) as
        | string
        | undefined,
  );
